import codexData from "../../data/codex.json";

export const REVIEW_TEXT_MIN_LENGTH = 20;
export const REVIEW_TEXT_MAX_LENGTH = 2_000;

const REVIEW_TOKEN_PATTERN = /^v1_[A-Za-z0-9_-]{43}$/;
const NAME_PATTERN = /^[\p{L}\p{M}][\p{L}\p{M}.'’ -]*$/u;

export const reviewCharacters = codexData
  .filter(
    (entry) =>
      entry.is_published === true &&
      (entry.category === "Unhuan" || entry.category === "Pehuan"),
  )
  .map((entry) => entry.title);

export function readReviewToken(hash) {
  const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const token = params.get("token") ?? "";
  return REVIEW_TOKEN_PATTERN.test(token) ? token : "";
}

function validateName(value, label) {
  const name = value.trim().replace(/\s+/g, " ");
  if (!name || name.length > 60 || !NAME_PATTERN.test(name)) {
    return `Enter a valid ${label}.`;
  }
  return "";
}

export function validateReviewForm(values) {
  const errors = {};
  const firstNameError = validateName(values.firstName, "first name");
  const lastNameError = validateName(values.lastName, "last name");
  const reviewLength = values.reviewText.trim().length;

  if (firstNameError) errors.firstName = firstNameError;
  if (lastNameError) errors.lastName = lastNameError;
  if (
    reviewLength < REVIEW_TEXT_MIN_LENGTH ||
    reviewLength > REVIEW_TEXT_MAX_LENGTH
  ) {
    errors.reviewText = `Write between ${REVIEW_TEXT_MIN_LENGTH} and ${REVIEW_TEXT_MAX_LENGTH} characters.`;
  }
  if (!reviewCharacters.includes(values.favoriteCharacter)) {
    errors.favoriteCharacter = "Choose your favourite character.";
  }

  return errors;
}

export function buildReviewPayload(token, values) {
  return {
    token,
    firstName: values.firstName.trim().replace(/\s+/g, " "),
    lastName: values.lastName.trim().replace(/\s+/g, " "),
    reviewText: values.reviewText.trim(),
    favoriteCharacter: values.favoriteCharacter,
  };
}
